if (!customElements.get('g3d-sticker-configurator')) {
  customElements.define('g3d-sticker-configurator', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.configurations = JSON.parse(this.querySelector('[data-config]').textContent);
      this.lastSelection = new Map();
      this.addEventListener('click', event => {
        const brand = event.target.closest('[data-brand]');
        const graphic = event.target.closest('[data-variant]');
        if (brand) this.select(this.lastSelection.get(brand.dataset.brand) || this.configurations.find(v => v.brand === brand.dataset.brand));
        if (graphic) this.select(this.configurations.find(v => v.id === graphic.dataset.variant));
      });
      this.select(this.configurations.find(v => v.id === this.dataset.selected) || this.configurations[0]);
    }
    select(config) {
      if (!config) return;
      this.lastSelection.set(config.brand, config);
      this.dataset.selected = config.id;
      this.querySelectorAll('[data-brand]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.brand === config.brand)));
      const availableGraphics = this.configurations.filter(v => v.brand === config.brand);
      this.querySelector('[data-graphics-label]').textContent = availableGraphics.length < 2 ? 'Grafica selezionata' : 'Scegli grafica';
      this.querySelectorAll('[data-variant]').forEach(b => {
        b.hidden = b.dataset.variantBrand !== config.brand;
        b.setAttribute('aria-pressed', String(b.dataset.variant === config.id));
      });
      for (const [selector, value] of [['brand', config.brand], ['graphic', config.graphic], ['size', config.size]]) {
        this.querySelector(`[data-${selector}-value]`).textContent = value;
      }
      this.querySelector('[data-price]').textContent = config.price;
      const form = this.querySelector('form');
      form.elements.namedItem('id').value = config.id;
      form.elements.namedItem('properties[Marca forcella]').value = config.brand;
      form.elements.namedItem('properties[Grafica]').value = config.graphic;
      form.elements.namedItem('properties[Dimensione]').value = config.size;
      this.querySelector('[data-buy]').disabled = !config.available;
    }
  });
}
